import { render, staticRenderFns } from "./Datadog.vue?vue&type=template&id=4eca3cc3&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eca3cc3')) {
      api.createRecord('4eca3cc3', component.options)
    } else {
      api.reload('4eca3cc3', component.options)
    }
    module.hot.accept("./Datadog.vue?vue&type=template&id=4eca3cc3&", function () {
      api.rerender('4eca3cc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/partnerIcons/Datadog.vue"
export default component.exports